import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  const features = ['+25.000 diseños en 26 carpetas organizadas', 'Tarjetas, invitaciones, packaging, globos y más', '5 bonos especiales (flores, letras 3D, colegio...)', 'Manual completo de uso e impresión', 'Licencia comercial — vendé sin límites', 'Descarga instantánea — acceso inmediato'];
  const headerRef = useRef(null);
  const isHeaderInView = useInView(headerRef, {
    once: true
  });
  const cardRef = useRef(null);
  const isCardInView = useInView(cardRef, {
    once: true,
    margin: '-100px'
  });
  return <section id="pricing" className="w-full bg-gradient-to-b from-pink-50 to-white py-20 sm:py-28" data-id="element-163">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        {/* Header */}
        <motion.div ref={headerRef} className="text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} animate={isHeaderInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-165">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-166">
            💰 Precio especial de lanzamiento
          </h2>
          <p className="text-xl sm:text-2xl font-bold text-rose-500 mb-4" data-id="element-167">
            Una Sola Inversión. Ingresos de Por Vida. 🌸
          </p>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-168">
            Todo lo que necesitás para lanzar tu negocio de imprimibles, en un
            solo pago sin sorpresas.
          </p>
        </motion.div>

        {/* Pricing Card */}
        <motion.div ref={cardRef} className="relative bg-white rounded-3xl shadow-2xl overflow-hidden pulse-glow" initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={isCardInView ? {
        opacity: 1,
        y: 0,
        scale: 1
      } : {}} transition={{
        duration: 0.7,
        delay: 0.2
      }} data-id="element-169">
          {/* Top badge */}
          <div className="bg-gradient-to-r from-rose-500 to-pink-500 py-4 text-center" data-id="element-170">
            <span className="text-white font-bold text-lg" data-id="element-171">
              🎀 Acceso completo — Todo incluido 🎀
            </span>
          </div>

          <div className="p-8 sm:p-12" data-id="element-172">
            {/* Price */}
            <div className="text-center mb-8" data-id="element-173">
              <p className="text-slate-400 line-through text-lg mb-2" data-id="element-174">
                Valor real: $89.990 ARS
              </p>
              <div className="flex items-baseline justify-center gap-2" data-id="element-175">
                <span className="text-6xl sm:text-7xl font-extrabold text-rose-600" data-id="element-176">
                  $27.990
                </span>
              </div>
              <p className="text-slate-500 mt-2" data-id="element-177">
                pesos argentinos · pago único
              </p>

              {/* Savings badge */}
              <motion.div className="inline-block mt-4 px-6 py-2 bg-gradient-to-r from-amber-400 to-amber-500 text-white font-bold rounded-full shadow-lg" initial={{
              scale: 0.8
            }} animate={isCardInView ? {
              scale: [0.8, 1.1, 1]
            } : {}} transition={{
              duration: 0.5,
              delay: 0.5
            }} data-id="element-178">
                🎉 Ahorrás más de $62.000 ARS
              </motion.div>
            </div>

            {/* Features list */}
            <ul className="space-y-4 mb-10" data-id="element-179">
              {features.map((feature, index) => <motion.li key={feature} className="flex items-start gap-3" initial={{
              opacity: 0,
              x: -20
            }} animate={isCardInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.4,
              delay: 0.6 + index * 0.08
            }} data-id="element-180">
                  <span className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center" data-id="element-181">
                    <CheckIcon className="w-4 h-4 text-green-600" data-id="element-182" />
                  </span>
                  <span className="text-slate-700" data-id="element-183">{feature}</span>
                </motion.li>)}
            </ul>

            {/* CTA Button */}
            <motion.a href="https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778" target="_blank" rel="noopener noreferrer" className="shimmer-btn block w-full py-5 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-xl font-bold rounded-2xl text-center shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300" initial={{
            opacity: 0
          }} animate={isCardInView ? {
            opacity: 1
          } : {}} transition={{
            duration: 0.4,
            delay: 1
          }} data-id="element-184">
              🛒 Comprar Ahora — $27.990 ARS
            </motion.a>

            {/* Trust line */}
            <p className="text-center text-sm text-slate-500 mt-6" data-id="element-185">
              🔒 Pago seguro · ⚡ Acceso inmediato · 🎀 Todo incluido
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}